<div class="kupari-multi-box-container" (click)="focusInput()">
  <input
    #hiddenInput
    class="kupari-multi-box-real-input"
    [type]="type"
    [disabled]="disabled"
    [attr.maxlength]="length"
    [value]="value"
    (keydown)="onKeyDown($event)"
    (beforeinput)="onBeforeInput($event)"
    (input)="onNativeInput($event)"
    (compositionstart)="onCompositionStart()"
    (compositionend)="onCompositionEnd($event)"
    (paste)="onPaste($event)"
    autocomplete="off"
    autocapitalize="off"
    spellcheck="false"

  />
  <div class="form-row row-gap-2">
  <div class="col-auto kupari-multi-boxes">
    <ng-container *ngFor="let idx of [].constructor(length); let i = index">
      <div class="char-box" (click)="selectIndex(i)" [ngClass]="{active: activeIndex(i), filled: value[i] && value[i] != ' '}">
        {{ value[i] || '' }}
      </div>
    </ng-container>
  </div>
  <button type="col button" class="ml-3 btn btn-sm btn-light" (click)="clear()">{{ 'common.actions.clear' | translate }}</button>
  </div>
</div>
<kupari-input-error [control]="controlDirective.control" [validation]="validation" [validationMessage]="validationMessage"
    [validationRule]="validationRule" [messagePosition]="messagePosition">
</kupari-input-error>
